import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { Button } from '../common/Button';
import { Input } from '../common/Input';
import { LoadingSpinner } from '../common/LoadingSpinner';
import config from '../../config/config';

export const AddWordDialog = ({ isOpen, onClose, onAdd }) => {
  const [word, setWord] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async () => {
    if (!word.trim()) {
      setError('Please enter a word or phrase');
      return;
    }

    if (word.includes('(') || word.includes(')')) {
      setError('Word cannot contain parentheses ( or )');
      return;
    }

    if (word.length > config.validation.maxWordLength) {
      setError(`Word must be ${config.validation.maxWordLength} characters or less`);
      return;
    }

    try {
      setIsLoading(true);
      setError('');
      setSuccessMessage('');

      const response = await onAdd(word.trim());

      // Handle different response types
      if (response?.action === 'level_updated') {
        setSuccessMessage('Word was mastered - moved back to learning!');
      } else if (response?.action === 'already_exists') {
        setSuccessMessage('Word already exists in your vocabulary.');
      } else if (response?.action === 'created') {
        setSuccessMessage('Word added successfully!');
      } else {
        setSuccessMessage('Word added successfully!');
      }

      // Show success message briefly, then close
      setTimeout(() => {
        setWord('');
        setSuccessMessage('');
        onClose();
      }, 1500);
    } catch (err) {
      setError(err.message || 'Failed to add word');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    if (!isLoading) {
      setWord('');
      setError('');
      setSuccessMessage('');
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Add New Word" size="md">
      <div className="space-y-4">
        <Input
          label="Word or Phrase"
          value={word}
          onChange={(e) => setWord(e.target.value)}
          placeholder="Enter a word or phrase..."
          maxLength={config.validation.maxWordLength}
          showCharCount
          error={error}
          disabled={isLoading}
        />

        {successMessage && (
          <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded">
            {successMessage}
          </div>
        )}

        {isLoading && (
          <div className="py-4">
            <LoadingSpinner />
            <p className="text-center text-sm text-gray-600 mt-2">
              Generating personalized examples with AI...
            </p>
          </div>
        )}

        <div className="flex justify-end gap-3 pt-4">
          <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? 'Adding...' : 'Add Word'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
